/* eslint @typescript-eslint/no-this-alias: "off" */
import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: 'minusSignToParens' })
export class MinusSignToParens implements PipeTransform {

  transform(value: undefined | null | string): string {
    return (value === null || typeof value == "undefined") ? '' : value.toString().minusSignToParens();
  }
}

declare global {
  interface String {
    minusSignToParens(): string;
  }
}

String.prototype.minusSignToParens = function() {
  let value = this.toString();
  const m = value.match('^\\((.*)\\)$');
  if (m) { // fix for edge
    value = m[1];
    if (value.match('[1-9]')) {
        value = '(' + value + ')';
    }
  }
  if (value.charAt(0) === '-') {
    value = value.substring(1, value.length);
    if (value.match('[1-9]')) {
      value = '(' + value + ')';
    }
  }
  return value;
}
